import { render, staticRenderFns } from "./fileSync.vue?vue&type=template&id=4ab12f50&"
import script from "./fileSync.vue?vue&type=script&lang=js&"
export * from "./fileSync.vue?vue&type=script&lang=js&"
import style0 from "./fileSync.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports